// Triple J Bali — Site-wide constants
// Final values per Master Prompt (override any older docs)

export const SITE = {
  brand: "Triple J Bali",
  tagline: "Simple Luxury Linen Wear for Bali",
  whatsappUrl: "https://wa.me/6287866842039",
  whatsappNumberDisplay: "+62 878-6684-2039",
  instagram: "https://www.instagram.com/triplejshopbali/",
  instagramHandle: "@triplejshopbali",
  hours: "Open Daily 9 AM – 9 PM",
  hoursShort: "9 AM – 9 PM",
  cangguMaps: "https://maps.app.goo.gl/xzFJVv9zpBp1Rqes7",
  ubudMaps: "https://maps.app.goo.gl/jR9tZJTPdRB7M9Rt7",
  logoLight: "/images/logo/triple-j-bali-logo-dark-on-light.webp",
  logoDark: "/images/logo/triple-j-bali-logo-light-on-dark.webp",
  metaTitle: "Triple J Bali | Linen Clothing Store in Canggu & Ubud",
  metaDesc:
    "Shop premium linen-focused clothing for Bali days at Triple J Bali. Visit our Canggu and Ubud stores for breathable, elegant outfits for men and women.",
};

export const REVIEWS = [
  {
    name: "Nicholas Hughes",
    text: "Great quality linen shorts and shirts. Well priced compared to other stores in the area. Very nice staff!",
  },
  {
    name: "Matthew Brookes",
    text: "Beautiful shop for top quality pieces, Ema’s customer service is amazing, I have shopped all over the world and never had this level of friendly and attentive service, will be back soon - highly recommend! 🙏 …",
  },
  {
    name: "Nina Brajdic",
    text: "Great clothes, love the linen they carry! Also Ema is so wonderful and helpful! She picked my whole outfit!",
  },
  {
    name: "Juliana Marcs",
    text: "The cutest little shop!! I love all the linen pieces! They are beautiful and very well made.",
  },
  {
    name: "Dara To",
    text: "Finally a store with affordable trendy clothes in downtown Canggu. I finally bought my first linen clothing, 3 at that! And they were on sale. I was trying so many pieces, and the lady, Emma, who helped was so nice and patient with me.",
  },
  {
    name: "Nicole Grieves",
    text: "Such a cute store! Found some really unique items and for a reasonable price too. Staff were great!",
  },
  {
    name: "Miia Stav",
    text: "Service was great and the outfit I brought is perfect. Quality is amazing definitely recommend",
  },
  {
    name: "Eliza Green",
    text: "Beautiful clothes that I haven’t seen at other shops before. Such helpful and approachable staff, Emma was very kind and helped with opinions on what to buy! I will have to shop here again",
  },
  {
    name: "Joelle Luck",
    text: "Really friendly staff and beautiful clothes. I bought a beautiful top. I will come back!",
  },
  {
    name: "Nimo Khalif",
    text: "Very good service, bought a maroon silk dress, good customer service and dress quality.",
  },
];

export const FAQS = [
  {
    q: "What does Triple J Bali sell?",
    a: "Triple J Bali offers premium linen-focused clothing and resort wear for men and women, designed for Bali’s tropical lifestyle.",
  },
  {
    q: "Where are your stores located?",
    a: "We have two stores in Bali: Canggu and Ubud. You can open each location directly through Google Maps.",
  },
  {
    q: "What time are you open?",
    a: "We are open daily from 9 AM to 9 PM.",
  },
  {
    q: "Can I order online?",
    a: "Yes. You can browse our collection, add items to your bag, and complete your order through WhatsApp.",
  },
  {
    q: "Do you offer delivery?",
    a: "Yes. Delivery is available to selected Bali areas. The delivery fee depends on distance and will be confirmed via WhatsApp.",
  },
  {
    q: "Can I pick up in store?",
    a: "Yes. Store pickup is available at our Canggu or Ubud store after our team confirms availability.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept cash, card, international card, and selected mobile payments. Payment details will be confirmed by our team.",
  },
  {
    q: "Is the stock shown on the website real-time?",
    a: "No. Availability may vary between stores, so our team will confirm stock via WhatsApp.",
  },
  {
    q: "Are all products 100% linen?",
    a: "No. Triple J Bali is linen-focused, but some items may be made from cotton, silk, or linen-cotton blends. Product material is shown on each item.",
  },
  {
    q: "Can I custom the size or cutting?",
    a: "Yes. Custom sizing and cutting are available for selected pieces. Production usually takes 2–3 days and requires a 25% deposit.",
  },
];

export const HERO_SLIDES = [
  {
    src: "/images/hero/triple-j-bali-hero-lifestyle-01.webp",
    alt: "Triple J Bali linen-style clothing boutique lifestyle photo",
  },
  {
    src: "/images/lifestyle/triple-j-bali-lifestyle-shopping-01.webp",
    alt: "Triple J Bali shopping and service lifestyle photo",
  },
];
